import { i18n } from '@fs/zion-locale'

export function getGender(gender) {
  if (typeof gender !== 'string') return 'unknown'

  const normalized = gender.trim().toLowerCase()

  if (normalized === 'http://gedcomx.org/male') return 'male'
  if (normalized === 'http://gedcomx.org/female') return 'female'
  if (normalized === 'male' || normalized === 'female') return normalized

  return 'unknown' // in  case of nonbinary or unknown gender
}

export const newAncestorTemplate = (year, person, region, language, header, additionalText) => {
  return {
    id: 39,
    icon: '',
    image: '',
    type: 'ancestorDetails',
    title: i18n.t('aam.content.about-your-ancestor', 'About your ancestor'),
    header,
    year,
    person,
    region,
    language,
    additionalText,
  }
}
